import { render } from "./transactionView.vue?vue&type=template&id=1a49a73f"
import script from "./transactionView.vue?vue&type=script&lang=js"
export * from "./transactionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__